export default __webpack_public_path__ + "static/media/business-model-frameworks.84e45a63.svg";